import { Box } from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import RankingListItem from './RankingListItem';
import RankingListFilter from './RankingListFilter';
import { Empty } from 'antd';
import TARMContainer from '../TARMContainer';

const RankingList = ({ rankingList: initialRankingList, rankingListType, routePath }) => {
  const [rankingList, setRankingList] = useState(initialRankingList);

  // Memoize unique author emails
  const authorEmails = useMemo(() => {
    const emails = initialRankingList.map((item) => item.author_email);
    return [...new Set(emails)];
  }, [initialRankingList]);

  // Filter functions
  const filterByAuthor = (selectedEmails) => {
    return selectedEmails.length
      ? initialRankingList.filter((item) => selectedEmails.includes(item.author_email))
      : initialRankingList;
  };

  const filterByName = (name) => {
    const lowerCaseName = name.toLowerCase();
    return initialRankingList.filter((item) => {
      const poolName = item.pool_name?.toLowerCase() || '';
      const poolValue = item.pool?.value?.toLowerCase() || '';
      return poolName.includes(lowerCaseName) || poolValue.includes(lowerCaseName);
    });
  };

  const handleAuthorChange = (selectedEmails) => {
    const filteredRankingList = filterByAuthor(selectedEmails);
    setRankingList(filteredRankingList);
  };

  const handleNameChange = (e) => {
    const filteredRankingList = filterByName(e.target.value);
    setRankingList(filteredRankingList);
  };

  const handleFilterChange = () => {
    setRankingList(initialRankingList);
  };

  return (
    <TARMContainer heading={rankingListType}>
      <Box borderWidth="3px" borderRadius="lg" p="10" width="800px">
        {initialRankingList.length === 0 ? (
          <Empty description={`No ${rankingListType} Found`} />
        ) : (
          <>
            <RankingListFilter
              onFilterChange={handleFilterChange}
              onChangeAuthor={handleAuthorChange}
              onChangeName={handleNameChange}
              authorEmails={authorEmails}
            />
            {rankingList.length === 0 ? (
              <Empty description="No Matching Data Found" />
            ) : (
              <RankingListItem rankingList={rankingList} routePath={routePath} />
            )}
          </>
        )}
      </Box>
    </TARMContainer>
  );
};

export default RankingList;
